/**
 * Capital Gains Tax regime configuration — single source of truth + the reform on/off switch.
 * Ported verbatim from frontend/src/constants/cgtReform.js.
 */
export const CGT_REGIME = {
    /** Master switch. false => behave exactly as the pre-reform 50% discount regime, app-wide. */
    reformEnabled: true,

    /** Reform commences for gains accruing on/after this date. */
    commencementDate: '2027-07-01',

    /** Pre-reform / grandfathered / pre-commencement discount (the legacy 50% CGT discount). */
    discountRate: 0.50,

    /** Minimum holding period for the discount / for the reform to apply (12 months). */
    minDiscountHoldingMonths: 12,

    /** Minimum (floor) tax rate on the real (post-commencement, indexed) gain. */
    minimumTaxRate: 0.30,

    /**
     * Means-tested income-support recipients (e.g. Age Pension, JobSeeker) are exempt from the 30%
     * minimum tax in any year they receive a payment.
     */
    incomeSupportExempt: true,

    /** Retained 60% discount for qualifying affordable housing (unchanged by the reform). */
    affordableHousingDiscountRate: 0.60,

    /**
     * Default CPI used to index the cost base of the POST-commencement slice of a gain.
     * Only relevant once `commencementDate` has passed. Callers that know the plan's own inflation
     * assumption (projections do) should pass it instead of relying on this.
     *
     * This must never be left at 0: indexation IS the reform's replacement for the 50% discount, so a
     * zero CPI would tax the whole nominal post-commencement gain and materially overstate CGT.
     */
    defaultCpiRate: 0.025,

    /**
     * When a CGT asset has no cost base recorded, assume a cost base of 25% of current value (i.e. a 75%
     * gain) — a conservative default. Adviser-overridable via the asset's actual cost base.
     */
    assumedCostBaseFraction: 0.25,
};

export default CGT_REGIME;
